import { ChartSkeleton } from '@/components';
import { SYMBOLS_PALETTE } from '@/constants';
import { BarChart, CurrencyValue } from '@blockanalitica/ui';
import { ChartConfig } from '@blockanalitica/ui/package/types/src/components/charts/Chart';
import { SimpleChartData } from '@blockanalitica/ui/package/types/src/components/charts/SimpleChart';
import { ReactNode, useMemo } from 'react';

export interface AssetData {
  symbol: string;
  value: string;
}

export default function AssetLiquidationsGraph({
  data,
  timeFilter,
  ...rest
}: {
  data: AssetData[];
  timeFilter?: ReactNode;
}) {
  const datasets = useMemo(() => {
    if (!data) return [];

    return [
      {
        xField: 'symbol',
        yField: 'value',
        label: 'Assets',
        backgroundColor: data.map((asset) => SYMBOLS_PALETTE[asset.symbol])
      }
    ];
  }, [data]);

  const xScaleValueFormatter = useMemo(() => {
    return (value: string) => {
      return data[value]?.symbol;
    };
  }, [data]);

  const subValueFormatter = useMemo(() => {
    return function subValueFormatter(value: string) {
      return <>Asset: {value}</>;
    };
  }, []);

  const valueFormatter = useMemo(() => {
    return function valueFormatter(value: string) {
      return (
        <CurrencyValue
          value={value}
          options={{
            currency: 'USD'
          }}
        />
      );
    };
  }, []);

  const config: ChartConfig = useMemo(() => {
    return {
      options: {
        scales: {
          x: {
            type: 'category'
          }
        }
      }
    };
  }, []);
  if (data) {
    return (
      <BarChart
        data={data as unknown as SimpleChartData[]}
        datasets={datasets}
        config={config}
        xScaleValueFormatter={xScaleValueFormatter}
        subValueFormatter={subValueFormatter}
        valueFormatter={valueFormatter}
        timeFilter={timeFilter}
        {...rest}
      />
    );
  }
  return <ChartSkeleton />;
}
